import template from './sw-cms-element-manufacturer-component.html.twig';

const {
    Component
} = Shopware;

Component.register('sw-cms-element-manufacturer-component', {
    template,

    mixins: [
        'cms-element'
    ],

    created() {
        this.createdComponent();

    },

    methods: {
        createdComponent() {
            this.initElementConfig('manufacturer-element');
        }
    }
});